module.exports = __webpack_public_path__ + "img/GOBIERNO_NL_LOGO-02.42b39a01.png";